import { render, staticRenderFns } from "./showApprovalEvaluation.vue?vue&type=template&id=c2084584&scoped=true"
import script from "./showApprovalEvaluation.vue?vue&type=script&lang=js"
export * from "./showApprovalEvaluation.vue?vue&type=script&lang=js"
import style0 from "./showApprovalEvaluation.vue?vue&type=style&index=0&id=c2084584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2084584",
  null
  
)

export default component.exports